import React, { PureComponent } from 'react';
import DocumentTitle from 'react-document-title';
import { AutoSizer } from 'react-virtualized';
import './Contacts.scss'
import GoogleMapReact from 'google-map-react';
import CONFIG from '../../config';
import { Link } from 'react-router-dom'


const defaultCenter = {
  lat: 56.9659834,
  lng: 24.1415005
};

const Point = () => (
  <div className="point">
    <i className="icon home"/>
  </div>
)

const contacts = [{
  name: 'Agate Kauliņa',
  image: 'agate-kaulina',
  role: 'Direktore',
  phone: '+371 67717655',
  mobile: '+371 26037892',
  email: 'agate.kaulina@medialine.lv',
}, {
  name: 'Baiba Sūna',
  image: 'baiba-suna',
  role: 'Projektu vadītāja',
  phone: '+371 67717665',
  mobile: '+371 27731055',
  email: 'baiba@medialine.lv',
}, {
  name: 'Liene Kļava',
  image: 'liene-klava',
  role: 'Projektu vadītāja',
  phone: '+371 67717658',
  mobile: '+371 29720949',
  email: 'liene@medialine.lv'
}, {
  name: 'Liene Zeme',
  image: 'liene-zeme',
  role: 'Projektu vadītāja',
  phone: '+371 67717661',
  mobile: '+371 26869123',
  email: 'liene.zeme@medialine.lv'
}];

export default class Contacts extends PureComponent {
  render() {
    return (
      <div id="contacts" className="d-flex flex-column">
        <DocumentTitle title="Kontakti - e-BML" />
        <div className="top">
          <div className="orderable">
            <div className="container">
              <h1 className="mt-md-5 mt-3">Kontakti</h1>
              <div className="row mt-md-5 mt-3 mb-1 mb-md-4">
                  {contacts.map(({name, image, role, phone, mobile, email}, idx) => (
                  <div className="col-12 col-sm-4 col-lg item" key={idx}>
                    <img src={`/images/${image}.jpg`} alt={name} className="mb-3 hidden-xs-down"
                         srcSet={`/images/${image}@2x.jpg 2x,
                                 /images/${image}@3x.jpg 3x`} />
                    <h4>{name}</h4>
                    <address>
                      <strong>{role}</strong><br />
                      <strong>Tālr.</strong> {phone}<br />
                      <strong>Mob.tālr.</strong> {mobile}<br />
                      {email}
                    </address>
                  </div>
                  ))}
              </div>
            </div>
            <div className="credentials pt-1 pb-1">
              <div className="container">
                <div className="row mt-md-5 mt-3 mb-1 mb-md-4">
                  <div className="col-12 col-lg item mb-3">
                    <h4>SIA “Baltic Media Line”</h4>
                    VRN: 40203035897<br />
                    Adrese: Cēsu iela 31, k-3<br />
                    Rīga, LV-1012
                  </div>
                  <div className="col-12 col-lg item mb-3">
                    A/S "Swedbank"<br />
                    HABALV22<br />
                    LV49HABA0551042752661                
                  </div>
                  <div className="col-12 col-lg mb-3">
                    SIA "Baltic Media line" kopš 2012. gada izvieto vides reklāmu uz visiem satiksmes pārvadiem un tiltiem Rīgā, 30 reklāmas vietās uz  Krasta ielas posmā no Mola līdz Dienvidu tiltam, lielformāta reklāmas uz vairāk kā 100 brandmūriem visā pilsētā. Izstrādāsim  vides prasībām atbilstošu maketu, saskaņosim projektu būvvaldē, izgatavosim LED gaismas reklāmas,   banerus, planšetes, noformēsim automašīnas, skatlogus un vitrīnas. Papildus info pieprasīt e-pastā  birojs@medialine.lv
                    <p><Link to="/tos">Iepazīties ar mājas lapas lietošanas noteikumiem</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom col">
          <AutoSizer>
            {size => (size.width && size.height)
              ? (<div style={size}>
                  <GoogleMapReact
                    defaultCenter={defaultCenter}
                    defaultZoom={15}
                    resetBoundsOnResize={true}
                    bootstrapURLKeys={{key: CONFIG.GOOGLE_MAP_KEY}}
                  >
                    <Point {...defaultCenter} />
                  </GoogleMapReact>
                </div>
                )
              : <span /> }
          </AutoSizer>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Contacts/index.js